import { render, staticRenderFns } from "./TopNewsImportant.vue?vue&type=template&id=01b71756&scoped=true&"
import script from "./TopNewsImportant.vue?vue&type=script&lang=js&"
export * from "./TopNewsImportant.vue?vue&type=script&lang=js&"
import style0 from "./TopNewsImportant.vue?vue&type=style&index=0&id=01b71756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b71756",
  null
  
)

export default component.exports